import AjaxResolver from 'owd/module/ajax';

export default class LangResolver extends AjaxResolver {
	shouldPushState() {
		return true;
	}

	pageIn() {
		const deferred = $.Deferred();

		$('body').removeClass('has-lang-resolver-working');

		return deferred.promise();
	}

	pageOut() {
		const deferred = $.Deferred();

		$('body').removeClass('menu-visible').addClass('has-default-resolver-working');

		$('[data-lang-resolver-item]').transition({
			opacity: 0
		}, 600, 'ease-out', () => {
			deferred.resolve();
		});

		return deferred.promise();
	}

	updateContent($loadedContent) {
		const deferred = $.Deferred();

		const bodyClass = $loadedContent.find('.overall').data('body-class');
		const bodyTheme = $loadedContent.find('.overall').data('theme');

		const $currItems = $('[data-lang-resolver-item]');
		const $newItems = $loadedContent.find('[data-lang-resolver-item]');

		if (this.preventUpdateBodyClass !== true) {
			$('body').attr('class', bodyClass);
			$('body').attr('data-theme', bodyTheme);
		}

        $currItems.each((i, obj) => {
            $(obj).after($newItems.eq(i));
            $(obj).remove();
        });

		deferred.resolve($currItems, $newItems);

		return deferred.promise();
	}
}
